<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import chevron from "@core/assets/icons/chevron.svg?raw";
	import translations from "./Stepper.translations.json" with { type: "json" };
	import Button from "./common/Button.svelte";
	import { ButtonSize } from "./common/ButtonSize.js";
	import { ButtonVariant } from "./common/ButtonVariant.js";
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";

	const translate = getTranslate(translations);
	let {
		current = $bindable(0),
		/* eslint-disable prefer-const */
		max,
		/* eslint-enable prefer-const */
	}: { max: number; current: number } = $props();
</script>

<div class="flex justify-between gap-4 items-center px-4 py-2 md:px-12 sticky top-0 bg-white z-10 min-h-11">
	<div>
		{#if current > 0}
			<Button
				variant={ButtonVariant.Outlined}
				size={ButtonSize.Custom}
				class="normal-case text-sm/none w-22 justify-center py-2 tracking-wide"
				onclick={(): void => {
					current--;
				}}
			>
				<Icon icon={chevron} class="size-6 rotate-90" />
				<div class="w-9 mr-2">
					<Formatted text={translate("back")} />
				</div>
			</Button>
		{/if}
	</div>
	<div class="flex gap-4 items-center">
		<div class="text-[0.6875rem]/none text-uppercase font-medium text-gray mr-1.5">
			<Formatted text={translate("label", { count: current + 1, max })} />
		</div>
		{#each Array.from({ length: max }) as _, index (index)}
			<button
				type="button"
				class={["w-4.5 h-[.1875rem] rounded-sm", current === index ? "bg-fcrdarkgray" : "bg-fcrlightgray"]}
				title={translate("chooseStep", { count: index + 1 })}
				onclick={(): void => {
					current = index;
				}}
			></button>
		{/each}
	</div>
</div>
